module.exports = "<img class=logo src=https://www.baidu.com/img/bd_logo1.png> <div class=searchbox-wrap> <div class=search> <div class=\"search_input ui_search_box\"> <span class=search_sr> <input type=text id=search_text> </span> <div class=suggest_nc id=search_result> </div> </div> <span class=search_btn> <input type=submit value=\"{{ btnValue }}\" id=submit_btn> </span> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
 ** module id = 9
 ** module chunks = 0
 **/